import React from "react"
import styled from "styled-components"
import { getCssSizeValue, getMapKey } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"

// const Wrapper = styled(GridContainer)`
// 	position: absolute;
// 	width: 100%;
// 	bottom: 0;
// 	left: 0;
// `

const Wrapper = styled.div`
	--col: calc((100% - var(--grid-gap) * 14) / 15);
	position: absolute;
	display: flex;
	width: 100%;
	bottom: 0;
	left: 0;

	column-gap: ${getCssSizeValue(50, BREAKPOINTS.TABLET)};
	margin-bottom: ${getCssSizeValue(36, BREAKPOINTS.TABLET)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		margin-left: calc(var(--col) + (var(--grid-gap) * 15 / 16));
		margin-bottom: ${getCssSizeValue(36)};
		column-gap: ${getCssSizeValue(50, BREAKPOINTS.DESKTOP)};
	}
`

const YearIndicator = styled.div`
	--color: ${({ theme }) => theme.colors.white};
	--width: ${getCssSizeValue(36, BREAKPOINTS.MOBILE)};
	width: var(--width);
	aspect-ratio: 1;
	position: relative;
	display: block;
	transition: border var(--rgr-duration) var(--ease);
	border: solid 1px transparent;
	cursor: pointer;

	&:after {
		content: " ";
		position: absolute;
		top: 50%;
		left: 50%;
		translate: -50% -50%;
		width: calc(var(--width) / 6);
		aspect-ratio: 1;
		transition: background-color var(--rgr-duration) var(--ease);
		background-color: var(--color);
	}

	&.active,
	&:hover {
		border: solid 1px var(--color);
	}

	&:hover {
		--color: ${({ theme }) => theme.colors.periwinkle};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		--width: ${getCssSizeValue(36)};
	}
`

const Counter = ({ data, currentIndex = 0, onIndicatorClick }) => {
	const array = Array.isArray(data) ? data : []
	if (array.length <= 1) return
	return (
		<Wrapper className="no-margin indent-desktop-1">
			{array.map((item, index) => (
				<YearIndicator
					key={getMapKey(item, index)}
					onClick={() => onIndicatorClick(index)}
					className={`${index === currentIndex ? "active" : ""}`}
				/>
			))}
		</Wrapper>
	)
}

export default Counter
